import { render, staticRenderFns } from "./gate-keeper.vue?vue&type=template&id=4798daf3&scoped=true&"
import script from "./gate-keeper.vue?vue&type=script&lang=js&"
export * from "./gate-keeper.vue?vue&type=script&lang=js&"
import style0 from "./gate-keeper.vue?vue&type=style&index=0&id=4798daf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4798daf3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/nsdua/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4798daf3')) {
      api.createRecord('4798daf3', component.options)
    } else {
      api.reload('4798daf3', component.options)
    }
    module.hot.accept("./gate-keeper.vue?vue&type=template&id=4798daf3&scoped=true&", function () {
      api.rerender('4798daf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/page/gate-keeper.vue"
export default component.exports